<template>
  <div>
    <section>
      <div class="container-lg p-0">
        <b-breadcrumb class="m-0 bg-transparent">
          <b-breadcrumb-item :to="{name:'webSetting'}">
            <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            網站設定
          </b-breadcrumb-item>
          <b-breadcrumb-item href="#" active>調整資料</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </section>
    <div class="container-lg pt-1 p-0 custom-shadow border-top">
      <div class="row no-gutters">
        <div class="col-12">
          <div class="d-flex justify-content-center">
            <b-card border-variant="light" bg-variant="transparent" body-border-variant="white"
              body-bg-variant="white" body-class="p-0" header-border-variant="white"
              header-bg-variant="transparent" header-class="px-0 pt-2 pb-0"
              footer-border-variant="white" footer-bg-variant="white" class="w-100">

              <template v-slot:header>
                <ul class="nav nav-tabs nav-pills flex-nowrap overflow-x-auto">
                  <li class="nav-item text-nowrap" v-for="list in modelList"
                    :key='"list__"+list.values'>

                    <a class="nav-link" :class="{active:pageName === list.page}"
                      @click="changePage(list.page)">{{list.name}}</a>
                  </li>
                </ul>
              </template>
              
              <b-card-body>
                <div class="d-flex flex-fill">
                  <component :is="getComponentPage"></component>
                </div>
              </b-card-body>

              <template v-slot:footer>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-sm btn-outline-success ml-2"
                    @click="saveWebSetting()">儲存</button>
                  <button class="btn btn-sm btn-outline-danger ml-2">取消</button>
                </div>
              </template>

            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ctrl from "@/js/webSetting/webManage"
  export default ctrl;

</script>
